import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import { container, buttonPrimary, heading2 } from 'app/sofia/resources/theme/css'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import TopBorder from 'resources/svg/bg-categories-top.svg'
import BottomBorder from 'resources/svg/bg-categories-bottom.svg'
import Shape from 'resources/svg/shape-categories.svg'

export const Container = styled.div`
  padding: 30px 0 5px;
  position: relative;
  z-index: 1;
  margin-bottom: 100px;
  background: ${props => props.theme.palette.primary.gammaLight};
  ${bp('sm')`
    margin-bottom: 10px;
  `}

  &::before {
    content: '';
    width: 100%;
    height: 100px;
    position: absolute;
    background: url(${TopBorder}) no-repeat center bottom;
    background-size: 100vw;
    top: -90px;
    z-index: 2;
  }

  &::after {
    content: '';
    width: 100%;
    height: 100px;
    position: absolute;
    background: url(${BottomBorder}) no-repeat center top;
    background-size: 100vw;
    bottom: -90px;
    z-index: -1;
  }

  > div {
    ${container}

    &::before,
    &::after {
      content: '';
      width: 200px;
      height: 500px;
      background: url(${Shape}) no-repeat left bottom;
      position: absolute;
      z-index: -1;
    }

    &::before {
      left: 0;
      top: 0;
      transform: rotate(180deg);
      ${bp('sm')`
        left: -70px;
      `}
    }

    &::after {
      right: 0;
      bottom: 0;
      ${bp('sm')`
        background-size: contain;
        right: -130px;
        transform: rotate(20deg);
      `}
    }
  }

  h2 {
    ${heading2}
    text-align: center;
  }

  ul {
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;

    @media (max-width: ${BREAKPOINT.MD}) {
      flex-wrap: wrap;
      justify-content: center;
    }

    li {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      @media (max-width: ${BREAKPOINT.MD}) {
        margin: 10px 25px;
      }

      ${bp('sm')`
        margin: 20px 10px;
      `}

      img {
        max-width: 100%;
        height: 170px;
      }

      a {
        ${buttonPrimary};
        background-color: ${props => props.theme.palette.general.light};
        border-color: ${props => props.theme.palette.general.light};
        color: ${props => props.theme.palette.general.strong};
        margin-top: auto;

        &:visited {
          background-color: ${props => props.theme.palette.general.light};
          border-color: ${props => props.theme.palette.general.light};
          color: ${props => props.theme.palette.general.strong};
        }

        &:hover {
          background: ${props => props.theme.palette.primary.alphaDark};
          border-color: ${props => props.theme.palette.primary.alphaDark};
          color: ${props => props.theme.palette.general.light};
        }
      }
    }
  }
`
